var _path, _path2, _path3, _rect, _circle, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuscle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.002C27.2188 24.002 20.8438 24.002 15 24.002C15 19.5837 18.8056 16.002 23.5 16.002C28.1944 16.002 32 19.5837 32 24.002Z",
    fill: "#EFB7A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.002C11 21.9082 11 17.7832 11 14.002C14.3137 14.002 17 16.4644 17 19.502C17 22.5395 14.3137 25.002 11 25.002Z",
    fill: "#EFB7A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.502H11L13.5 11.002",
    stroke: "#EFB7A4",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.7998,
    y: 4.00195,
    width: 13,
    height: 11,
    rx: 5.5,
    fill: "#EFB7A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 11.502,
    r: 2.5,
    fill: "#EFB7A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9689 25.7347C16.8078 26.17 16.1922 26.17 16.0311 25.7347L15.3644 23.933C15.3137 23.7961 15.2058 23.6882 15.069 23.6376L13.2673 22.9709C12.8319 22.8098 12.8319 22.1941 13.2673 22.033L15.069 21.3663C15.2058 21.3157 15.3137 21.2078 15.3644 21.0709L16.0311 19.2692C16.1922 18.8339 16.8078 18.8339 16.9689 19.2692L17.6356 21.0709C17.6863 21.2078 17.7942 21.3157 17.931 21.3663L19.7327 22.033C20.1681 22.1941 20.1681 22.8098 19.7327 22.9709L17.931 23.6376C17.7942 23.6882 17.6863 23.7961 17.6356 23.933L16.9689 25.7347Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9689 15.7327C24.8078 16.1681 24.1922 16.1681 24.0311 15.7327L22.8242 12.4712C22.7736 12.3344 22.6656 12.2264 22.5288 12.1758L19.2673 10.9689C18.8319 10.8078 18.8319 10.1922 19.2673 10.0311L22.5288 8.8242C22.6656 8.77355 22.7736 8.66565 22.8242 8.52879L24.0311 5.26725C24.1922 4.83194 24.8078 4.83194 24.9689 5.26725L26.1758 8.52879C26.2264 8.66565 26.3344 8.77355 26.4712 8.8242L29.7327 10.0311C30.1681 10.1922 30.1681 10.8078 29.7327 10.9689L26.4712 12.1758C26.3344 12.2264 26.2264 12.3344 26.1758 12.4712L24.9689 15.7327Z",
    fill: "#F18854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscle);
export default __webpack_public_path__ + "static/media/muscle.d58edb92744f7a2be742ec4f8c254c9a.svg";
export { ForwardRef as ReactComponent };